import React from 'react';
import PropTypes from 'prop-types';
import {BoundBox} from '../../';
import root from 'window-or-global';

export default class ReactionsSection extends React.Component {
    static propTypes = {
        active: PropTypes.bool,
        footerActive: PropTypes.bool,
        reactionsData: PropTypes.object,
        activeSlide: PropTypes.number,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    nextSlide = () => {
        $.fn.fullpage.moveSlideRight();
    };

    prevSlide = () => {
        $.fn.fullpage.moveSlideLeft();
    };

    render() {
        const {active, reactionsData} = this.props;
        const contentStyle = active ? 'content active' : 'content';
        if (this.props.active) this.imagesLoaded = true;
        const reactions = reactionsData.items.map((item, i) => {
            let image;
            if (!root.__server_side_render && (this.props.active || this.props.footerActive || this.imagesLoaded)) {
                image = this.props.mobile || this.props.tablet ? item.background.tabletImage : item.background.content[0];
            }
            const style = {};
            if (image) {
                const url = `url("${image}")`;
                style.backgroundImage = url;
            }
            return (
                <div className="slide" key={`reaction-${item.title}`}>
                    <div className="bodyContainer" style={style}>
                        <BoundBox
                            title={item.title}
                            body={item.description}
                            cta={item.cta}
                            active={this.props.active}
                            activeSlide={this.props.activeSlide}
                            slideNumber={i} />
                    </div>
                </div>
            );
        });

        return (
            <div id="reactionsSection" className="section">
                <div className={contentStyle}>
                    <h1>{reactionsData.title}</h1>
                </div>
                {reactions}
                <div className={`slide-navigation ${this.props.active ? 'active' : ''}`}>
                    <i role="presentation" className="icon-prevArrow" onClick={this.prevSlide} />
                    <i role="presentation" className="icon-nextArrow" onClick={this.nextSlide} />
                </div>
            </div>
        );
    }
}
